import { useEffect } from 'react';
import { Clock } from 'lucide-react';
import { useStudioStore } from '@/stores/useStudioStore';

export function StudioHistory() {
  const { history, historyLoading, loadHistory, loadWorkbook, workbook } = useStudioStore();

  useEffect(() => {
    loadHistory();
  }, [loadHistory]);

  if (historyLoading && history.length === 0) {
    return <div className="py-4 text-center text-xs text-text-light">Loading history...</div>;
  }

  if (history.length === 0) {
    return <div className="py-4 text-center text-xs text-text-light">No studio workbooks yet.</div>;
  }

  return (
    <div className="space-y-1.5">
      {history.map((item) => {
        const isActive = workbook?.id === item.id;
        const date = new Date(item.created_at);
        const timeStr = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short',
          hour: '2-digit',
          minute: '2-digit',
        });

        return (
          <button
            key={item.id}
            onClick={() => loadWorkbook(item.id)}
            className={`flex w-full items-start gap-2 rounded-lg border px-3 py-2 text-left transition-colors ${
              isActive ? 'border-brand bg-brand-light' : 'border-border hover:border-brand/50'
            }`}
          >
            <Clock size={14} className="mt-0.5 shrink-0 text-text-light" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-text-primary">{item.title}</p>
              <p className="text-xs text-text-muted">
                {item.theme} &middot; {item.block_count ?? '?'} blocks &middot; {timeStr}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
